(() => {
  if (window.monzoroProductGalleryReady) return;
  window.monzoroProductGalleryReady = true;
  const instances = new WeakMap();
  function initialize(root = document) {
    root.querySelectorAll('.Product__Gallery--compact').forEach((gallery) => {
      if (instances.has(gallery)) return;
      const slideshow = gallery.querySelector('.Product__Slideshow');
      const slides = Array.from(gallery.querySelectorAll('.Product__SlideItem'));
      const thumbnails = Array.from(gallery.querySelectorAll('.Product__SlideshowNavImage'));
      const dots = Array.from(gallery.querySelectorAll('.Product__SlideshowMobileNav .dot'));
      const counter = gallery.querySelector('.MonzoroGallery__counter');
      const previous = gallery.querySelector('[data-direction="previous"]');
      const next = gallery.querySelector('[data-direction="next"]');
      const scroller = gallery.querySelector('.Product__SlideshowNavScroller');
      if (!slideshow || !slides.length) return;
      let lastIndex = -1;
      let frame = 0;
      const sync = () => {
        frame = 0;
        const index = slides.findIndex(slide => slide.classList.contains('is-selected'));
        if (index < 0) return;
        const selected = slides[index];
        if (selected.classList.contains('Product__SlideItem--hidden')) selected.classList.remove('Product__SlideItem--hidden');
        slides.forEach((slide, position) => {
          if (slide.dataset.mediaType === 'image') slide.tabIndex = position === index ? 0 : -1;
        });
        [...thumbnails, ...dots].forEach(control => {
          const active = control.dataset.mediaId ? control.dataset.mediaId === selected.dataset.mediaId : Number(control.dataset.index) === index;
          if (active) control.setAttribute('aria-current', 'true');
          else control.removeAttribute('aria-current');
        });
        if (counter && lastIndex !== index) {
          counter.textContent = `${index + 1} / ${slides.length}`;
          counter.setAttribute('aria-label', counter.dataset.positionTemplate.replace('__NUMBER__', index + 1));
        }
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
        if (lastIndex !== index && scroller && thumbnails[index]) {
          const thumb = thumbnails[index];
          const vertical = getComputedStyle(scroller).flexDirection === 'column';
          const thumbRect = thumb.getBoundingClientRect();
          const railRect = scroller.getBoundingClientRect();
          const offset = vertical
            ? thumbRect.top - railRect.top + scroller.scrollTop - (scroller.clientHeight - thumb.offsetHeight) / 2
            : thumbRect.left - railRect.left + scroller.scrollLeft - (scroller.clientWidth - thumb.offsetWidth) / 2;
          scroller.scrollTo({[vertical ? 'top' : 'left']: Math.max(0, offset), behavior: 'auto'});
        }
        lastIndex = index;
      };
      const observer = new MutationObserver(() => { if (!frame) frame = requestAnimationFrame(sync); });
      slides.forEach(slide => observer.observe(slide, {attributes: true, attributeFilter: ['class']}));
      const onKeyDown = (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || event.target !== slideshow) return;
        slides.forEach(slide => slide.classList.remove('Product__SlideItem--hidden'));
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          dots[event.key === 'Home' ? 0 : dots.length - 1]?.click();
        }
      };
      const onResize = () => { lastIndex = -1; if (!frame) frame = requestAnimationFrame(sync); };
      window.addEventListener('resize', onResize);
      slideshow.addEventListener('keydown', onKeyDown, true);
      instances.set(gallery, () => { observer.disconnect(); cancelAnimationFrame(frame); window.removeEventListener('resize', onResize); slideshow.removeEventListener('keydown', onKeyDown, true); });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.Product__Gallery--compact').forEach(gallery => { instances.get(gallery)?.(); instances.delete(gallery); }));
})();

